import { alpha, SxProps, Theme } from '@mui/material';

export const PILL_HOVER_CARD_ACTION_CLASS = 'pill-hover-card-action';

// Theme's MuiTooltip styleOverrides add their own border/shadow/background; strip
// them so the card is the only layer drawing chrome. Must go through
// slotProps (styled(Tooltip)'s className lands on the child, not the portaled popper).
export const BARE_TOOLTIP_SLOT_SX: SxProps<Theme> = {
  padding: 0,
  margin: '0.25rem 0 0',
  backgroundColor: 'transparent',
  border: 'none',
  boxShadow: 'none',
  maxWidth: 'none',
};

export const pillHoverCardSx: SxProps<Theme> = {
  width: '15.75rem',
  backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerLow,
  border: (theme) => `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: '0.625rem',
  padding: '0.625rem 0.75rem',
  boxShadow: (theme) => `0 0.5rem 1.5rem ${alpha(theme.palette.custom.OV.sys.shadow, 0.35)}`,
};

export const pillHoverCardTitleTextSx = (wrap: boolean): SxProps<Theme> => ({
  fontSize: '0.78125rem',
  fontWeight: 600,
  color: (theme) => theme.palette.custom.OV.sys.onBackground,
  minWidth: 0,
  flex: 1,
  ...(wrap && {
    lineHeight: 1.35,
    wordBreak: 'break-all',
    userSelect: 'text',
  }),
});

export const pillHoverCardInfoRowSx: SxProps<Theme> = {
  fontSize: '0.71875rem',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  py: '0.125rem',
  minWidth: 0,
  [`&:hover .${PILL_HOVER_CARD_ACTION_CLASS}`]: { opacity: 1 },
};

export const pillHoverCardInfoValueSx: SxProps<Theme> = {
  fontSize: 'inherit',
  color: (theme) => theme.palette.custom.OV.sys.onBackground,
  userSelect: 'text',
  minWidth: 0,
};

export const pillHoverCardActionSx: SxProps<Theme> = {
  display: 'inline-flex',
  flexShrink: 0,
  marginLeft: 'auto',
  opacity: 0,
  transition: 'opacity 120ms',
};
